var _rect, _rect2, _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 13,
  viewBox: "0 0 12 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 2.5,
  width: 11,
  height: 10,
  rx: 1.5,
  stroke: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 8.5,
  width: 2,
  height: 2,
  rx: 1,
  stroke: "currentColor"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  y1: 6.5,
  x2: 12,
  y2: 6.5,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 1V4",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 1V4",
  stroke: "currentColor",
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };